import React from 'react'
import Helmet from 'react-helmet'
import { GlobalFooter } from 'components/organisms/footer/global_footer'
import { GlobalHeader } from 'components/organisms/header/global_header'
import 'semantic-ui-less/semantic.less'
import * as styles from './layout.module.sass' // eslint-disable-line no-restricted-imports

const Layout = ({ url = undefined, children }) => (
  <>
    <Helmet
      title="効果的な販促・集客 法人向けデジタルギフト"
      meta={[
        {
          name: 'description',
          content:
            'giftee for Businessとは、スタバやコンビニなど有名ブランドの商品をノベルティとして活用できる、今話題のキャンペーンツールです。選べる商品は1000種類以上、価格帯も100円から幅広く取り揃えており、デジタルギフトで顧客満足度の高いマーケティング、プロモーション施策を実現します。',
        },
        {
          name: 'keywords',
          content: 'デジタルギフト, キャンペーン, giftee',
        },
        {
          property: 'og:url',
          content: url || 'https://giftee.biz',
        },
        {
          property: 'og:title',
          content: '効果的な販促・集客 法人向けデジタルギフト',
        },
        {
          property: 'og:description',
          content:
            'giftee for Businessとは、スタバやコンビニなど有名ブランドの商品をノベルティとして活用できる、今話題のキャンペーンツールです。選べる商品は1000種類以上、価格帯も100円から幅広く取り揃えており、デジタルギフトで顧客満足度の高いマーケティング、プロモーション施策を実現します。',
        },
        {
          property: 'og:site_name',
          content: 'giftee for Business',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:image',
          content: 'https://giftee.biz/assets/images/ogps/default.png',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:site',
          content: '@_giftee',
        },
      ]}
      link={[
        {
          rel: 'shortcut icon',
          type: 'image/x-icon',
          href: '/assets/images/favicon.ico',
        },
        {
          rel: 'apple-touch-icon',
          type: 'image/png',
          sizes: '180x180',
          href: '/assets/images/apple-touch-icon.png',
        },
      ]}
    />
    <GlobalHeader />
    <main className={styles.wrapper}>
      <div className={styles.content}>{children}</div>
    </main>
    <GlobalFooter />
  </>
)

export { Layout }
